import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Collapse } from 'react-bootstrap';
import { each } from 'lodash';

function Instructions({name, type}) {
  let instructions = null;
  if (type === 'force') {
    if (name  === 'Organization' || name === 'UserRole' || name === 'Profile') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions in the &ldquo;Systems Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['View Roles and Role Hierarchy', 'View Setup and Configuration'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'Opportunity' || name === 'OpportunityStage' || name === 'OpportunityHistory' || name === 'OpportunityCompetitor') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Opportunities&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'Account') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Accounts&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'OpportunityLineItem') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Opportunities&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
          <p>Also enable the following permissions under the &ldquo;Price Books&rdquo; object in the same section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
          <p>Also enable the following permissions under the &ldquo;Products&rdquo; object in the same section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'Product2') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Products&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'Contact') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Contacts&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'ActivityHistory') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;System Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['View All Data'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'OpportunityContactRole') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Contacts&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
          <p>Also enable the following permissions under the &ldquo;Opportunities&rdquo; object in the same section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'AccountContactRelation') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Account Contact Relationships&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Read'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'GongContact') {
      // TODO: What are the display names of the Gong__Gong_Call__c and Gong__Call_Participant__c objects? - #1749 MW 2023-06-28
    } else if (name === 'CanAddContact') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Contacts&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Create'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
          <p>Also enable the following permissions in the &ldquo;Systems Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['View Setup and Configuration'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    } else if (name === 'CanAddOpportunityContactRole') {
      instructions = (
        <div>
          <p>To enable permissions for the {name}, enable the following permissions under the &ldquo;Opportunities&rdquo; object in the &ldquo;Object Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['Edit'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
          <p>Also enable the following permissions in the &ldquo;Systems Permissions&rdquo; section of the integration user&lsquo;s Salesforce profile:</p>
          <ul>{['View Setup and Configuration'].map((p) => <li key={p}>&ldquo;{p}&rdquo;</li>)}</ul>
        </div>
      );
    }
  }
  if (!instructions) {
    return null;
  }
  return (
    <div className="alert alert-default">
      {instructions}
    </div>
  );
}
Instructions.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

function Row(props) {
  const { permission, name, organization } = props;

  const isError = permission.error !== undefined;
  const isOptional = permission.warning !== undefined;
  const message = isError ? permission.error : permission.warning;
  const [show, setShow] = useState(false);
  const cls = isError ? 'text-danger' : 'text-warning';

  return (
    <div>
      {isError || isOptional
      ? (
        <a
          href=""
          className={cls}
          style={{ textDecoration: 'underline' }}
          onClick={(e) => {
            e.preventDefault();
            setShow(!show);
          }}
        >
          <Fa name="exclamation-triangle" /> Permission Missing ({isOptional ? 'Optional' : 'Required'})
        </a>
      )
      : (
        <div className="text-success"><Fa name="check-circle" /> Permission Present</div>
      )}
      {message && <Collapse in={show}>
        <div className={cls}>
          <div className={`alert ${isOptional ? 'alert-warning' : 'alert-danger'}`}>{message}</div>
          <Instructions name={name} type={organization.type} />
        </div>
      </Collapse>}
    </div>
  );
}
Row.propTypes = {
  permission: PropTypes.shape({
    error: PropTypes.string,
    warning: PropTypes.string,
  }).isRequired,
  name: PropTypes.string,
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
};

class PermissionTable extends Component {
  render() {
    const { permissions, organization } = this.props;
    const rows = [];
    each(permissions, (permission, name) => {

      rows.push((
        <tr key={name}>
          <td className="text-left" width="200"><code><nobr>{name}</nobr></code></td>
          <td className="text-left">
            <Row permission={permission} name={name} organization={organization} />
          </td>
        </tr>
      ));
    });
    return (
      <div>
        <table className="table table-striped table-condensed">
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
}
PermissionTable.propTypes = {
  permissions: PropTypes.shape({}),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default PermissionTable;
